import { render, staticRenderFns } from "./EditVendor.vue?vue&type=template&id=378ef6ce&scoped=true&"
import script from "./EditVendor.vue?vue&type=script&lang=js&"
export * from "./EditVendor.vue?vue&type=script&lang=js&"
import style0 from "./EditVendor.vue?vue&type=style&index=0&id=378ef6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ef6ce",
  null
  
)

export default component.exports